import { Link } from "@tanstack/react-router";
import { LogomarkTile } from "@/components/brand/LogomarkTile";

export function NotFoundPage() {
  return (
    <main className="mx-auto flex max-w-md flex-col items-center gap-4 p-6 pt-24 text-center">
      <LogomarkTile />
      <h1 className="text-h3">Page not found</h1>
      <p className="text-body text-text-secondary">This corner of the district hasn&apos;t been built yet, or the link is out of date.</p>
      <Link
        to="/feed"
        className="inline-flex h-9 items-center justify-center rounded-sm bg-primary px-4 text-button text-text-on-primary hover:bg-primary-hover"
      >
        Back to feed
      </Link>
    </main>
  );
}
